import api from './api';

export const roleService = {
    // Get all roles
    getRoles: async () => {
        try {
            const response = await api.get('/roles');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data role'
            };
        }
    },

    // Get all permissions
    getPermissions: async () => {
        try {
            const response = await api.get('/permissions');
            return { success: true, data: response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengambil data permission'
            };
        }
    },

    // Create role
    createRole: async (roleData) => {
        try {
            const response = await api.post('/roles', roleData);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal membuat role'
            };
        }
    },

    // Update role
    updateRole: async (id, roleData) => {
        try {
            const response = await api.put(`/roles/${id}`, roleData);
            return { success: true, data: response.data, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal mengupdate role'
            };
        }
    },

    // Delete role
    deleteRole: async (id) => {
        try {
            const response = await api.delete(`/roles/${id}`);
            return { success: true, message: response.data.message };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menghapus role'
            };
        }
    }
};